import { FC } from 'react'

import { Card } from '@joor/design-system'

import { ExternalPaymentQuery } from '__generated__/atlas-types'

import { Flex } from 'styles/components'
import { decimalWithCommas } from 'utils/formatters'

import {
  CardItemHeader,
  CardItemInfo,
} from '../../PublicInvoice/components/styles'
import { StyledLink } from './Payments.style'

const FinancialInfo: FC<{
  externalPayment: ExternalPaymentQuery['externalPaymentByLink']
}> = ({
  externalPayment: { paymentId, amount, currency, attachments, notes },
}) => (
  <Card title="Financial Info">
    <Flex flexDirection="column" rowGap="20px">
      <div>
        <CardItemHeader>Payment ID</CardItemHeader>
        <CardItemInfo>{paymentId}</CardItemInfo>
      </div>
      <div>
        <CardItemHeader>Payment Amount</CardItemHeader>
        <CardItemInfo>
          {decimalWithCommas(amount)} {currency}
        </CardItemInfo>
      </div>
      <div>
        <CardItemHeader>Attachments</CardItemHeader>
        {attachments?.map(({ fileName, url }) => (
          <StyledLink href={url} key={url} target="_blank">
            {fileName}
          </StyledLink>
        ))}
      </div>
      <div>
        <CardItemHeader>Notes</CardItemHeader>
        <CardItemInfo>{notes}</CardItemInfo>
      </div>
    </Flex>
  </Card>
)
export default FinancialInfo
